class Merchant {
    merchant_settings = []
    getLogo = () => {
        return this.logo_url ? this.display_logo : "";
    }
}

export default Merchant;